import "reset-css";
import "normalize.css";
import "./styles/main.scss";
import "./custom.scss";
import "symbol-observable"; // Polyfill Symbol.observable

import React from "react";
import thunk from "redux-thunk";
import ReactDOM from "react-dom";
import { createLogger } from "redux-logger";
import { Provider } from "react-redux";
import { DragDropContextProvider } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import promise from "redux-promise-middleware";
import { createBrowserHistory } from "history";
import { Router } from "react-router-dom";
import { createReduxHistoryContext } from "redux-first-history";
import { injectReducer } from "redux-injector";
import { dynamicMiddlewaresInstance, store } from "@dized/ui/dist/redux/store";

import Routes from "./routes";
import api from "./middleware/api_middleware";
import attempt from "./middleware/attempt_middleware";
import createRootReducer from "./reducers"; // Ensure this is correctly imported

const history = createBrowserHistory();

const { routerMiddleware: reduxFirstRouterMiddleware, createReduxHistory } =
  createReduxHistoryContext({
    history,
    store,
    createRootReducer,
  });

const logger = createLogger({
  collapsed: true,
});

// inject application middlewares
dynamicMiddlewaresInstance.addMiddleware(promise());
dynamicMiddlewaresInstance.addMiddleware(logger);
dynamicMiddlewaresInstance.addMiddleware(thunk);
dynamicMiddlewaresInstance.addMiddleware(reduxFirstRouterMiddleware);
dynamicMiddlewaresInstance.addMiddleware(attempt);
dynamicMiddlewaresInstance.addMiddleware(api);

// inject application reducers
Object.entries(createRootReducer(history)).forEach(([key, reducer]) =>
  injectReducer(key, reducer)
);

const reduxHistory = createReduxHistory(store);

ReactDOM.render(
  <Provider store={store}>
    <Router history={reduxHistory}>
      <DragDropContextProvider backend={HTML5Backend}>
        <Routes history={reduxHistory} />
      </DragDropContextProvider>
    </Router>
  </Provider>,
  document.getElementById("root")
);
